"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconBtn = exports.Icon = exports.MessageWrapper = exports.Label = exports.Row = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.Row = styled_components_1.default.div `
  display: flex;
  align-items: center;
  padding: 0 8px;
  height: ${(props) => (props.isTheme ? "48px" : "32px")};
  padding: ${(props) => (props.isTheme ? "0 16px" : "0 8px")};
  font-size: ${(props) => (props.isTheme ? "16px" : "14px")};

  &:hover {
    ${(props) => !props.isTheme && ` background: ${colors_1.LIGHT_GREY};`}
  }

  & label,
  & span {
    ${(props) => props.newItem && `animation: colorChange 1s`}
  }

  @keyframes colorChange {
    0% {
      color: currentColor;
    }

    100% {
      color: ${colors_1.DARK_GREEN};
    }
  }

  > label {
    flex-grow: 1;
    width: ${(props) => (props.isTheme ? "auto" : "200px")};
  }
  > div,
  abbr {
    width: 50px;
    text-align: center;

    :last-child {
      text-align: right;
      width: ${(props) => (props.isTheme ? "auto" : "50px")};
    }
  }
`;
exports.Label = styled_components_1.default.label `
  font-size: ${(props) => (props.isTheme ? "16px" : "14px")};
  color: ${colors_1.GREY4};
  justify-self: flex-start;
  display: flex;
  align-items: center;

  label {
    font-size: 14px;
  }
`;
exports.MessageWrapper = styled_components_1.default.div ``;
exports.Icon = styled_components_1.default.label `
  display: flex;
  font-size: 14px;
  color: ${colors_1.GREY4};

  ${(props) => props.enableTooltip &&
    ` cursor: pointer;
            &:hover {
            text-decoration: underline;
    }  
        &:hover div {
        visibility: visible;
    }`};
`;
exports.IconBtn = styled_components_1.default.div `
  visibility: hidden;
  margin-left: 5px;
  cursor: pointer;
`;
//# sourceMappingURL=MultiCalculationRow.styles.js.map